import { createElement } from 'react';
const Container = function Container({ style: styleOption = {}, layout, children, isTab, tab, ...otherProps }) {
    return (createElement("div", { ...otherProps, style: { height: '100%', ...styleOption } }, children));
};
export default Container;
